import api from './base'

export default {
  findForDevice ({ electronicDeviceId, number, dateFrom, dateTo, paymentType }) {
    let url = `company/electronic_devices/${electronicDeviceId}/invoices?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (number) {
      url += `&invoiceNumber=${number}`
    }
    if (paymentType) {
      url += `&paymentType=${paymentType}`
    }
    return api().get(url)
  },
  najdiSteviloRacunov (electronicDeviceId) {
    let url = `company/business_units/${electronicDeviceId}/invoices?recentCount=20`
    return api().get(url)
  },
  findForBusinessUnit ({ businessUnitId, dateFrom, dateTo, start, size, onlyClients, paymentType }) {
    return api().get(`company/business_units/${businessUnitId}/invoices?dateFrom=${dateFrom}&dateTo=${dateTo}&start=${start}&size=${size}&typePerClient=${onlyClients ? 1 : 0}&paymentType=${paymentType}`)
  },
  update ({ invoiceId, data }) {
    return api().patch(`company/invoices/${invoiceId}`, data)
  },
  save ({ electronicDeviceId, data }) {
    return api().put(`company/electronic_devices/${electronicDeviceId}/invoices`, data)
  },
  createMissingInvoice ({ electronicDeviceId, data }) {
    return api().put(`company/electronic_devices/${electronicDeviceId}/missing_invoices`, data)
  },
  reverseInvoice ({ invoiceId, data }) {
    return api().delete(`company/invoices/${invoiceId}`, { data })
  },
  setPrints ({ id, data }) {
    return api().post(`company/invoices/${id}/prints`, data)
  },
  getPrints ({ id }) {
    return api().get(`company/invoices/${id}/prints?printType=0`)
  },
  getPdf ({ id, data }) {
    // treba pocakat Janeza, da naredi pdf ..
    return api().post(`company/invoices/${id}/pdf`, data)
  },
  getInvoicesPdf ({ businessUnitId, dateFrom, dateTo, clientOnly = false, client = null, paymentType = null }) {
    let url = `invoice_list_report/pdf?businessUnit=${businessUnitId}&dateFrom=${dateFrom}&dateTo=${dateTo}&clientOnly=${clientOnly}`
    if (client !== null) {
      url = url + `&client=${client}`
    }
    if (paymentType !== null) {
      url = url + `&paymentType=${paymentType}`
    }
    return api().get(url)
  },
  getInvoicesExcel ({ businessUnitId, dateFrom, dateTo, clientOnly = false, client = null, paymentType = null }) {
    let url = `invoice_list_report/xlsx?businessUnit=${businessUnitId}&dateFrom=${dateFrom}&dateTo=${dateTo}&clientOnly=${clientOnly}`
    if (client !== null) {
      url = url + `&client=${client}`
    }
    if (paymentType !== null) {
      url = url + `&paymentType=${paymentType}`
    }
    return api().get(url)
  }
}
